import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Loading } from './components/ui';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const Market = lazy(() => import('./pages/Market'));
const Arbitrage = lazy(() => import('./pages/Arbitrage'));
const Crafting = lazy(() => import('./pages/Crafting'));
const Refining = lazy(() => import('./pages/Refining'));
const Farming = lazy(() => import('./pages/Farming'));
const Conversion = lazy(() => import('./pages/Conversion'));
const Scanner = lazy(() => import('./pages/Scanner'));
const History = lazy(() => import('./pages/History'));
const Favorites = lazy(() => import('./pages/Favorites'));
const Settings = lazy(() => import('./pages/Settings'));

export default function App() {
  return <Suspense fallback={<div className="route-loading"><Loading rows={6} /></div>}><Routes><Route element={<Layout />}><Route index element={<Dashboard />} /><Route path="markt" element={<Market />} /><Route path="arbitrage" element={<Arbitrage />} /><Route path="crafting" element={<Crafting />} /><Route path="refining" element={<Refining />} /><Route path="farming" element={<Farming />} /><Route path="verzauberung" element={<Conversion />} /><Route path="scanner" element={<Scanner />} /><Route path="preisverlauf" element={<History />} /><Route path="favoriten" element={<Favorites />} /><Route path="einstellungen" element={<Settings />} /><Route path="*" element={<Navigate to="/" replace />} /></Route></Routes></Suspense>;
}
